import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { hot } from 'react-hot-loader';

const iconStyles = {
	selectIcon: {
		color: 'green'
	}
};

const ExpandIcon = withStyles(iconStyles)(({ classes = {}, className = '', ...rest }) => {
	const isMobile = useMediaQuery({
		query: '(max-width: 450px)'
	});

	return (
		<div {...rest} className={clsx(className, classes.selectIcon)}>
			<svg
				fill="none"
				height={isMobile ? '15' : '20'}
				viewBox="0 0 20 20"
				width={isMobile ? '15' : '20'}
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M3.33331 13.3332L9.99998 6.6665L16.6666 13.3332"
					stroke="#111111"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
				/>
			</svg>
		</div>
	);
});

export default hot(module)(ExpandIcon);
